<template>
    <div class="animated fadeIn">
        <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-form>
          <h1>Login</h1>
          <p class="text-muted">Sign In to your account</p>
          <b-form-group description="Your Email">
            <b-form-input type="email" placeholder="Email" v-model="loginDetails.email"></b-form-input>
          </b-form-group>
          <b-form-group description="Your Password">
            <b-form-input type="password" placeholder="Password" v-model="loginDetails.password"></b-form-input>
          </b-form-group>
          <div class="row">
            <div class="col-6">
              <b-button class="px-4" variant="primary" v-on:click="login">
                Login
              </b-button>
            </div>
            <div class="text-right col-6">
              <router-link :to="{name: 'ResetPassword'}">
                <b-button class="px-4 btn-link" variant="clear">
                  Forgot password?
                </b-button>
              </router-link>
            </div>
          </div>
      </b-form>
    </div>
</template>
<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import router from '../../router'
    import {handleErrors} from "../../shared/utils";
    import {UserStorage} from "../../services/LocalStorage/UserStorage";
    import {TokenStorage} from "../../services/LocalStorage/TokenStorage";

    const LoginRepo = RepositoryFactory.get('login')

    export default {
        name: 'login-form',
        components: {
            VueLoading,
        },
        data() {
            return {
                loginDetails: {
                    email: null,
                    password: null,
                },
                isLoading: false,
            }
        },
        methods: {
            login() {
                this.isLoading = true,
                LoginRepo
                    .login(this.loginDetails)
                    .then(
                        response => (
                            this.isLoading = false,
                            UserStorage.storeUserId(response.data.data.userId),
                            TokenStorage.storeToken(response.data.data.token),
                            router.push({name: 'Home'})
                        )
                    )
                    .catch(response => (
                        this.returnErrors(response)
                    ))
            },
            returnErrors(response) {
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                ),
                this.isLoading = false
            },
        }
    }
</script>
